import { render, staticRenderFns } from "./user-card.vue?vue&type=template&id=30d704c6&scoped=true&"
import script from "./user-card.vue?vue&type=script&lang=js&"
export * from "./user-card.vue?vue&type=script&lang=js&"
import style0 from "./user-card.vue?vue&type=style&index=0&id=30d704c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d704c6",
  null
  
)

export default component.exports